/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Merchant } from "../../../../models";
import { MerchantService } from "../../../../services";

@Component({
  selector: "app-customer-contact-edit",
  templateUrl: "./customer-contact-edit.component.html"
})
export class CustomerContactEditComponent {
  @Input() parentGroup!: FormGroup;

  @Input() contacts!: FormGroup;
  @Input("merchant") merchant!: Merchant;

  constructor(private merchantService: MerchantService) {}

  isWorldPay(): boolean {
    return this.merchantService.isWorldPay(this.merchant);
  }

  get customerContactFormControl() {
    return this.contacts.controls;
  }
}
